import React from "react";
import { Route } from "react-router-dom";
import CustomerApproval from "../../../containers/modules/log/customer-approval";

export default function CustomerApprovalRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="customer-approval"
      index
      element={
        <CustomerApproval
         
        />
      }
    />
  );
}
